import $ from 'jquery';

class Accordion {
  constructor() {
    this.selectors = {
      accordion: '.js-accordion',
      button: '.js-accordion-button',
      row: '.js-accordion-row',
      content: '.js-accordion-content',
    };

    this.classes = {
      active: 'is-active',
    };

    this.initAccordions();
  }

  initAccordions() {
    this.accordions = $(this.selectors.accordion);

    if (!this.accordions.length) {
      return;
    }

    $.each(this.accordions, (i, el) => {
      const accordion = $(el);
      const button = accordion.find(this.selectors.button);

      button.on('click', e => {
        e.preventDefault();

        const self = $(e.currentTarget);

        // if (self.hasClass(this.classes.active)) {
        //   return;
        // }

        const target = self.attr('data-target');
        const row = self.closest(this.selectors.row);
        const content = row.find(`${this.selectors.content}${target}`);
        const activeContent = accordion
          .find(`${this.selectors.content}.${this.classes.active}`)
          .not(content);
        const activeButton = accordion
          .find(`${this.selectors.button}.${this.classes.active}`)
          .not(self);

        if (content.length) {
          if (self.hasClass(this.classes.active)) {
            self.removeClass(this.classes.active);
            content.slideUp(300, () => {
              content.removeClass(this.classes.active);
            });
          } else {
            self.addClass(this.classes.active);
            content.slideDown(300, () => {
              content.addClass(this.classes.active);
            });
            activeButton.removeClass(this.classes.active);
            activeContent.slideUp(300, () => {
              activeContent.removeClass(this.classes.active);
            });
          }
        }
      });
    });
  }
}

export default new Accordion();



// WEBPACK FOOTER //
// ./src/scripts/modules/accordion.js